/**
 * Route les lignes de passagers préremplies depuis un passager enregistré vers
 * `existingPassengerIds` (lien vers le passager du compte, pas de doublon), et ne
 * garde dans `newPassengers` que les passagers réellement saisis à la main.
 *
 * À appeler sur les valeurs BRUTES du formulaire (avant le parse zod), tant que les
 * lignes portent encore le marqueur interne `savedPassengerId`. Ne modifie pas le
 * contrat API : on se contente de répartir dans les deux champs déjà existants.
 */
export function routeSavedPassengers(value) {
    const rows = value.newPassengers ?? [];
    const linkedIds = [];
    const typedPassengers = [];
    for (const row of rows) {
        if (row.savedPassengerId) {
            linkedIds.push(row.savedPassengerId);
        }
        else {
            typedPassengers.push(row);
        }
    }
    // Fusionne avec d'éventuels ids déjà présents et déduplique.
    const existingPassengerIds = [...new Set([...(value.existingPassengerIds ?? []), ...linkedIds])];
    return {
        ...value,
        existingPassengerIds,
        newPassengers: typedPassengers,
    };
}
